/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancersWorkforceCountryResource
 */
export interface FreelancersWorkforceCountryResource {
    /**
     * The ISO 3166-1 alpha-2 country code.
     * @type {string}
     * @memberof FreelancersWorkforceCountryResource
     */
    countryCode?: string;
    /**
     * The country name in the current locale.
     * @type {string}
     * @memberof FreelancersWorkforceCountryResource
     */
    label?: string;
}

/**
 * Check if a given object implements the FreelancersWorkforceCountryResource interface.
 */
export function instanceOfFreelancersWorkforceCountryResource(value: object): value is FreelancersWorkforceCountryResource {
    return true;
}

export function FreelancersWorkforceCountryResourceFromJSON(json: any): FreelancersWorkforceCountryResource {
    return FreelancersWorkforceCountryResourceFromJSONTyped(json, false);
}

export function FreelancersWorkforceCountryResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancersWorkforceCountryResource {
    if (json == null) {
        return json;
    }
    return {
        
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function FreelancersWorkforceCountryResourceToJSON(value?: FreelancersWorkforceCountryResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'countryCode': value['countryCode'],
        'label': value['label'],
    };
}

